import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useLayout } from '../../contexts/LayoutContext';
import SideNav from './SideNav';
import MainContent from './MainContent';
import { ConversationRefreshProvider } from '../../contexts/ConversationRefreshContext';

import ConversationRouter from '../ConversationRouter';
import WelcomeScreen from '../common/WelcomeScreen';
import ConversationsPage from '../conversations/ConversationsPage';
import ProfileView from '../profile/ProfileView';
import Admin from '../admin/Admin';
import UserManagement from '../admin/UserManagement';
import TenantManagement from '../admin/TenantManagement';
import OrgManagement from '../admin/OrgManagement';
import GlobalContentManagement from '../admin/GlobalContentManagement';
import ReportingDashboard from '../reporting/ReportingDashboard';
import SystemManagement from '../admin/SystemManagement';
import UserActivityListPage from '../reporting/activity/UserActivityListPage';
import UserConversationListPage from '../reporting/activity/UserConversationListPage';
import ConversationDebriefPage from '../reporting/activity/ConversationDebriefPage';

import '../../styles/layout.css';

const AppLayout = () => {
  const { navCollapsed, isMobile, mobileNavOpen, closeMobileNav } = useLayout();

  // CSS class logic:
  // Desktop: nav-collapsed / nav-expanded controls the push layout
  // Mobile: nav is always "collapsed" visually (icons), mobileNavOpen adds the overlay
  const layoutClass = [
    'app-layout',
    navCollapsed ? 'nav-collapsed' : 'nav-expanded',
    isMobile ? 'is-mobile' : '',
    isMobile && mobileNavOpen ? 'mobile-nav-open' : '',
  ].filter(Boolean).join(' ');

  return (
    <ConversationRefreshProvider>
      <div className={layoutClass}>
        <SideNav />

        {/* Backdrop — only rendered on mobile when nav is open */}
        {isMobile && mobileNavOpen && (
          <div
            className="mobile-nav-backdrop"
            onClick={closeMobileNav}
            aria-hidden="true"
          />
        )}

        <MainContent>
          <Routes>
            <Route path="/" element={<WelcomeScreen />} />
            <Route path="/chat/:conversationId" element={<ConversationRouter />} />
            <Route path="/conversations" element={<ConversationsPage />} />
            <Route path="/profile" element={<ProfileView />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/tenants" element={<TenantManagement />} />
            <Route path="/org" element={<OrgManagement />} />
            <Route path="/content" element={<GlobalContentManagement />} />
            <Route path="/reports" element={<ReportingDashboard />} />
            <Route path="/reports/activity" element={<UserActivityListPage />} />
            <Route path="/reports/activity/users/:userId" element={<UserConversationListPage />} />
            <Route path="/reports/activity/users/:userId/conversations/:conversationId" element={<ConversationDebriefPage />} />
            <Route path="/my-activity" element={<UserConversationListPage />} />
            <Route path="/my-activity/conversations/:conversationId" element={<ConversationDebriefPage />} />
            <Route path="/system" element={<SystemManagement />} />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </MainContent>
      </div>
    </ConversationRefreshProvider>
  );
};

export default AppLayout;